<template>
	<div class="enable-map">
		<div @click="enable()">
			Godkänn för att få tillgång till kartan
		</div>

		<div class="enable-map-info" @click="readMore()">
			Läs mer om vad godkännandet innebär
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	props: ['consentCards'],

	methods: {
		enable() {
			this.$store.state.endUser.googleMapsConsent = true

			axios.post(this.$apiUrl + '/api/end-user/' + this.$store.state.endUser.slug + '/update-consent', {
			   consent: this.consentCard?.type_options?.consent_text,
			   answer: 'yes'
			})

			this.$store.commit('loadGoogleMaps')
		},

		readMore() {
			this.$deleteCookie('finishedPrestep')
			
			this.$router.push({name: 'EndUser'})
		}
	},

	computed: {
		consentCard() {
	    	let cards = this.$store.getters.cards
				.filter(c => c.type.includes('new_prestep_') && ! c.hidden
					&& ( ! c.lang || c.lang === this.$store.state.endUser.language)
					&& (c.type !== 'new_prestep_language' || c.type === 'new_prestep_language' && ! this.$route.query.lang)
					&& ! (c.type === 'new_prestep_address' && ! this.$store.state.endUser.googleMapsConsent)
				)
				.filter(c => c.type === 'new_prestep_consent')

			return cards[0] || null
		}
	}
}
</script>
